<div id="university-rankers" class="watermark py-5">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="title mb-5">University Rankers</h2>

        <!-- Tabs Navigation -->
        <ul class="nav nav-tabs justify-content-center mb-4 border-bottom-0 custom-tabs">
          <li class="nav-item" *ngFor="let ranker of rankers">
            <button 
              class="nav-link fs-5 px-4 py-2" 
              [class.active]="activeTab === ranker.year"
              (click)="setTab(ranker.year)">
              {{ ranker.year }}
            </button>
          </li>
        </ul>

        <!-- Tabs Content -->
        <div class="tab-content text-center">
          <ng-container *ngFor="let ranker of rankers">
            <div class="tab-pane fade" [class.show]="activeTab === ranker.year" [class.active]="activeTab === ranker.year">
              <img [src]="ranker.image" class="img-fluid shadow-lg rounded ranker-brochure" [alt]="'University Rankers ' + ranker.year">
            </div>
          </ng-container>
        </div>

      </div>
    </div>
  </div>
</div>
